import { useQuery } from '@tanstack/react-query'
import { getUnreadAnnouncementsCount } from '@/services/announcementService'
import { useAuthStore } from '@/store/authStore'

/**
 * Polling annunci non letti per il badge sidebar operatore.
 * Cadenza lenta (60s): gli annunci sono a bassa frequenza, non è una chat.
 */
export function useUnreadAnnouncements(): number {
  const role = useAuthStore((s) => s.user?.role)
  const enabled = role === 'OPERATOR'

  const { data } = useQuery({
    queryKey:        ['announcements', 'unread'],
    queryFn:         getUnreadAnnouncementsCount,
    refetchInterval: 60_000,
    enabled,
    staleTime:       30_000,
  })
  return data ?? 0
}
